import React, { Component } from "react";
import { Container, Row, Button, Col, Modal } from "reactstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import RequestManager from "../../singletons/RequestManager";
import LoadingOverlay from "react-loading-overlay";
import CalendarHolidayListModal from "../../components/CalendarHolidayListModal/CalendarHolidayListModal";

export default class CalendarHoliday extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinnerLoading: false,
      endDate: moment(),
      holidayModalVisible: false,
    };
  }

  toggleModal = () => {
    this.setState({
      holidayModalVisible: !this.state.holidayModalVisible,
    });
  };
  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Modal
          size="lg"
          isOpen={this.state.holidayModalVisible}
          toggle={this.toggleModal}
        >
          <CalendarHolidayListModal goBack={this.toggleModal} />
        </Modal>
        <Container fluid style={{ padding: 0, margin: 10 }}>
          <Col
            xs="12"
            sm="12"
            md="4"
            lg="4"
            style={{ display: "flex", alignItems: "center", margin: 10 }}
          >
            <h5>{"Holiday Calendar"}</h5>
            <Button
              style={{
                marginLeft: 20,
                backgroundColor: "green",
                color: "white",
              }}
              onClick={() => {
                this.toggleModal();
              }}
            >
              Show List of Holidays
            </Button>
          </Col>
          <Col>
            <h5>{"Select date"}</h5>
            <Row noGutters>
              <div
                style={{
                  justifyContent: "space-between",
                }}
              >
                <DatePicker
                  selected={this.state.endDate}
                  minDate={moment().endOf("day")}
                  dateFormat="DD/MM/YYYY"
                  id="input"
                  readonly
                  onChange={this.handleEndDateChange}
                />

                <Button
                  style={{
                    marginLeft: 20,
                    backgroundColor: "blue",
                    color: "white",
                  }}
                  onClick={() => {
                    this.updateStoreCalendarHoliday();
                  }}
                >
                  Submit
                </Button>
              </div>
            </Row>
          </Col>
        </Container>
      </LoadingOverlay>
    );
  }
  handleEndDateChange = (date) => {
    this.setState({
      endDate: date,
    });
  };

  updateStoreCalendarHoliday = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let requestManager = new RequestManager();

    let input = {
      input: {
        storeId: storeInformation.store.id,
        holidayDates:
          this.state.endDate.format("YYYY-MM-DD") + "T00:00:00+00:00",
      },
    };
    console.log("input", JSON.stringify(input));
    this.setState({ spinnerLoading: true });
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateStoreCalendarHoliday",
      input
    );

    if (response.error === null) {
      this.setState({ spinnerLoading: false });
    } else {
      this.setState({ spinnerLoading: false });
      alert(
        "Unable to update Store Status. Please check your internet connection."
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/pages/CalendarHoliday/CalendarHoliday.js